const sectionTemplateApplicabilityType = {
    OPTIONAL : 1,

    REQUIRED : 2,

    DEFAULT_SELECTED : 3,

    CONDITIONAL : 11

};

angular.module('gw-um-j2js')
    .constant('sectionTemplateApplicabilityType', sectionTemplateApplicabilityType);